export const tradingConfig = {
  // Stop loss percentage below entry price (for positions)
  stopLossPercentage: 5,
  
  // Target price percentage above pivot price
  targetPricePercentage: 10,
  
  // Conservative target (for lower-risk strategies)
  conservativeTargetPercentage: 7,
  
  // Aggressive target (for higher-risk strategies)  
  aggressiveTargetPercentage: 15,
  
  // Profit start percentage (when to start taking partial profits)
  profitStartPercentage: 7,
  
  // Position sizing (percentage of portfolio)
  defaultPositionSizePercentage: 25,
  
  // Maximum holding period in days
  maxHoldingDays: 28,
  
  // Pivot point trading parameters
  maxDistanceFromPivot: 5,
  minDistanceFromPivot: -5,
};